import React from 'react'
import './footerbtn.css'
import { useNavigate } from 'react-router-dom'
import { FaHome, FaList, FaShoppingCart } from 'react-icons/fa';
export default function FooterButton() {
    const navigate=useNavigate();
  return (
    <div className="footer">
<div className='btn-group'>
    <button className="btn" onClick={()=>navigate("/showproduct")}><FaHome style={{ fontSize: '20px', marginRight: '5px' }}></FaHome>Home</button>
    <button className="btn" onClick={() => navigate("/categories")}><FaList style={{ fontSize: '20px', marginRight: '5px' }}></FaList>Categories</button>
    <button className="btn"><FaShoppingCart style={{ fontSize: '20px', marginRight: '5px' }}></FaShoppingCart >Cart</button>
</div>

    </div>
  )
}
